module.exports = __webpack_public_path__ + "img/W-G35.1bbdb190.jpg";